<script setup>
import { router } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import CreateTeamForm from '@/Pages/Teams/Partials/CreateTeamForm.vue';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';

// const props = defineProps({
//     programme: Object,
//     organisation: Object,
// });

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

</script>

<template>
    <AppLayout title="Create Team">

        <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full">

            <div id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10">
                <DashboardSidebar :programme="programme" :organisation="organisation" />
            </div>


            <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden">
                    <h1 class="dashboard-title pt-5 pl-10">
                        {{ $t('teams.create.create_team') }}
                    </h1>
                    <div class="p-10 pt-5 lg:pr-0">
                        <CreateTeamForm :programme="programme" :organisation="organisation" />
                    </div>
                </div>
            </div>
        </div>

    </AppLayout>
</template>
